import { BoostProvider, BoostTask } from "../../types/boost";
import {
  getCPCBanner,
  postCPCBannerClick,
} from "../../../../Services/Requests";

interface DreamCoinBannerResponse {
  banner_id: string;
  title: string;
  description: string;
  image_url: string;
  link: string;
}

export class DreamCoinBoostProvider implements BoostProvider {
  private static instance: DreamCoinBoostProvider;
  private hasError: boolean = false;
  private lastTaskTime: number = 0;
  private readonly TASK_COOLDOWN = 5000;
  private currentBanner: DreamCoinBannerResponse | null = null;

  private constructor() {}

  public static getInstance(): DreamCoinBoostProvider {
    if (!DreamCoinBoostProvider.instance) {
      DreamCoinBoostProvider.instance = new DreamCoinBoostProvider();
    }
    return DreamCoinBoostProvider.instance;
  }

  private canShowNewTask(): boolean {
    return Date.now() - this.lastTaskTime >= this.TASK_COOLDOWN;
  }

  private isTelegramUrl(url: string): boolean {
    return url.includes("t.me/");
  }

  async startTask(
    taskId: string | number
  ): Promise<"success" | "ads_not_found" | "user_cancelled"> {
    console.log("Starting DreamCoin task with ID:", taskId);
    console.log("Current banner:", this.currentBanner);

    if (!this.canShowNewTask()) {
      console.log("Cannot start DreamCoin task: on cooldown");
      return "ads_not_found";
    }

    try {
      // Если нет текущего баннера или его ID не совпадает с taskId,
      // пробуем получить актуальный баннер
      if (
        !this.currentBanner ||
        this.currentBanner.banner_id.toString() !== taskId.toString()
      ) {
        console.log("Getting new banner data...");
        const response = await getCPCBanner();
        const banner = response as DreamCoinBannerResponse;

        if (!banner?.banner_id) {
          console.log("No valid banner data received");
          return "ads_not_found";
        }

        this.currentBanner = banner;
      }

      if (!this.currentBanner?.link) {
        console.log("Cannot start DreamCoin task: no valid link in banner");
        return "ads_not_found";
      }

      console.log("Opening link:", this.currentBanner.link);

      // Проверяем, является ли ссылка телеграм-ссылкой
      if (this.isTelegramUrl(this.currentBanner.link)) {
        window.Telegram.WebApp.openTelegramLink(this.currentBanner.link);
      } else {
        window.Telegram.WebApp.openLink(this.currentBanner.link);
      }

      // Отправляем информацию о клике
      await postCPCBannerClick(taskId as string);

      this.lastTaskTime = Date.now();
      return "success";
    } catch (error) {
      console.error("Error starting DreamCoin task:", error);
      this.hasError = true;
      return "ads_not_found";
    }
  }

  async getAvailableTasks(): Promise<BoostTask[]> {
    if (this.hasError) {
      return [];
    }

    try {
      const response = await getCPCBanner();
      const banner = response as DreamCoinBannerResponse;

      if (!banner?.banner_id) {
        console.log("No valid DreamCoin tasks found");
        return [];
      }

      // Сохраняем текущий баннер
      this.currentBanner = banner;
      console.log("Saved banner:", this.currentBanner);

      // Возвращаем только одно задание
      return [
        {
          id: `${banner.banner_id}`,
          title: banner.title || "Просмотреть рекламу",
          description: banner.description || "",
          provider: "DreamCoin",
          icon: banner.image_url,
          onClick: async () => {
            // При клике выполняем действие
            return this.startTask(banner.banner_id);
          },
        },
      ];
    } catch (error) {
      console.error("Error getting DreamCoin tasks:", error);
      this.hasError = true;
      return [];
    }
  }

  getName(): string {
    return "DreamCoin";
  }

  resetError() {
    this.hasError = false;
    this.lastTaskTime = 0;
    this.currentBanner = null;
  }
}

// Экспортируем уже созданный экземпляр
export const dreamCoinBoostProvider = DreamCoinBoostProvider.getInstance();
